<div class="fixed inset-0 z-50 flex items-center justify-center p-3 md:p-5 bg-slate-900/60 backdrop-blur-sm"
  (click)="onClose()">
  <div
    class="relative w-full max-w-4xl max-h-[92vh] bg-white dark:bg-slate-900 rounded-[2rem] shadow-2xl border border-slate-100/50 dark:border-slate-800 flex flex-col"
    (click)="$event.stopPropagation()">

    <!-- Header -->
    <div class="flex-none px-6 py-5 border-b border-slate-100 dark:border-slate-800 flex items-center justify-between gap-4 rounded-t-[2rem]">
      <div class="flex items-center gap-3">
        <div class="w-11 h-11 rounded-2xl bg-amber-50 dark:bg-amber-500/10 text-amber-500 flex items-center justify-center">
          <span class="material-icons">upload_file</span>
        </div>
        <div>
          <h3 class="text-xl font-bold text-slate-800 dark:text-slate-100">
            {{ step() === 'form' ? 'นำเข้าทะเบียนรถ (ช่วงยกเว้นค่าจอด)' : 'สรุปผลการนำเข้า' }}
          </h3>
          <p class="text-sm text-slate-500 dark:text-slate-400 font-medium">
            ลาน: <span class="font-semibold text-amber-600 dark:text-amber-400">{{ siteName || '—' }}</span>
          </p>
        </div>
      </div>
      <button type="button" (click)="onClose()" [disabled]="isImporting()"
        class="w-9 h-9 rounded-xl flex items-center justify-center text-slate-400 hover:text-slate-600 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors disabled:opacity-50 border-none bg-transparent cursor-pointer">
        <span class="material-icons">close</span>
      </button>
    </div>

    <!-- ================= FORM ================= -->
    <div *ngIf="step() === 'form'" class="flex-1 overflow-y-auto custom-scrollbar px-6 py-6">
      <div class="grid grid-cols-1 lg:grid-cols-[minmax(0,5fr)_minmax(0,7fr)] gap-6">

        <!-- Left: range + remark -->
        <div class="space-y-5">
          <div class="flex items-center gap-2 text-sm font-black text-slate-700 dark:text-slate-200">
            <span class="w-6 h-6 rounded-full bg-amber-400 text-white text-xs flex items-center justify-center">1</span>
            กำหนดช่วงวันเวลา (ใช้กับทุกคันในไฟล์)
          </div>

          <div class="rounded-2xl border border-slate-100 dark:border-slate-800 bg-slate-50/60 dark:bg-slate-800/40 p-4 space-y-4">
            <div>
              <label class="block text-[11px] font-bold text-slate-500 mb-1.5">เริ่มต้น <span class="text-rose-500">*</span></label>
              <div class="grid grid-cols-[1fr_104px] gap-2">
                <div class="relative">
                  <span class="absolute left-3 top-1/2 -translate-y-1/2 material-icons text-slate-400 text-[18px] pointer-events-none z-10">event</span>
                  <input type="text" [matDatepicker]="startPicker" [(ngModel)]="startDate" placeholder="dd/mm/yyyy" readonly
                    (click)="startPicker.open()" [disabled]="isImporting()"
                    class="w-full h-[44px] pl-10 pr-3 rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 text-sm font-bold cursor-pointer focus:outline-none focus:ring-2 focus:ring-amber-200">
                  <mat-datepicker #startPicker panelClass="modern-yellow-datepicker"></mat-datepicker>
                </div>
                <input type="text" inputmode="numeric" maxlength="5" placeholder="HH:mm" [(ngModel)]="startTime"
                  (blur)="onTimeBlur('start')" [disabled]="isImporting()"
                  class="w-full h-[44px] px-3 rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 text-sm font-bold text-center tabular-nums focus:outline-none focus:ring-2 focus:ring-amber-200">
              </div>
              <div class="flex flex-wrap gap-1.5 mt-2">
                <button *ngFor="let t of timePresets" type="button" (click)="setTime('start', t)"
                  class="px-2 py-0.5 rounded-lg text-[11px] font-bold border transition-colors cursor-pointer"
                  [ngClass]="startTime === t ? 'bg-amber-400 border-amber-400 text-white' : 'bg-white dark:bg-slate-800 border-slate-200 dark:border-slate-700 text-slate-500 hover:border-amber-300'">
                  {{ t }}
                </button>
              </div>
            </div>

            <div>
              <label class="block text-[11px] font-bold text-slate-500 mb-1.5">สิ้นสุด <span class="text-rose-500">*</span></label>
              <div class="grid grid-cols-[1fr_104px] gap-2">
                <div class="relative">
                  <span class="absolute left-3 top-1/2 -translate-y-1/2 material-icons text-slate-400 text-[18px] pointer-events-none z-10">event</span>
                  <input type="text" [matDatepicker]="endPicker" [(ngModel)]="endDate" [min]="startDate" placeholder="dd/mm/yyyy" readonly
                    (click)="endPicker.open()" [disabled]="isImporting()"
                    class="w-full h-[44px] pl-10 pr-3 rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 text-sm font-bold cursor-pointer focus:outline-none focus:ring-2 focus:ring-amber-200">
                  <mat-datepicker #endPicker panelClass="modern-yellow-datepicker"></mat-datepicker>
                </div>
                <input type="text" inputmode="numeric" maxlength="5" placeholder="HH:mm" [(ngModel)]="endTime"
                  (blur)="onTimeBlur('end')" [disabled]="isImporting()"
                  class="w-full h-[44px] px-3 rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 text-sm font-bold text-center tabular-nums focus:outline-none focus:ring-2 focus:ring-amber-200">
              </div>
              <div class="flex flex-wrap gap-1.5 mt-2">
                <button *ngFor="let t of timePresets" type="button" (click)="setTime('end', t)"
                  class="px-2 py-0.5 rounded-lg text-[11px] font-bold border transition-colors cursor-pointer"
                  [ngClass]="endTime === t ? 'bg-amber-400 border-amber-400 text-white' : 'bg-white dark:bg-slate-800 border-slate-200 dark:border-slate-700 text-slate-500 hover:border-amber-300'">
                  {{ t }}
                </button>
              </div>
            </div>

            <div *ngIf="rangePreview" class="flex items-center gap-2 text-xs font-bold rounded-xl px-3 py-2"
              [ngClass]="rangeInvalid ? 'bg-rose-50 text-rose-600 dark:bg-rose-900/20 dark:text-rose-400' : 'bg-amber-50 text-amber-700 dark:bg-amber-900/20 dark:text-amber-300'">
              <span class="material-icons text-[16px]">{{ rangeInvalid ? 'error_outline' : 'event_available' }}</span>
              {{ rangeInvalid ? 'วันเวลาสิ้นสุดต้องหลังวันเวลาเริ่มต้น' : rangePreview }}
            </div>
          </div>

          <div>
            <label class="block text-[11px] font-bold text-slate-500 mb-1.5">หมายเหตุ (ใช้กับทุกคัน)</label>
            <textarea [(ngModel)]="remark" rows="3" maxlength="250" [disabled]="isImporting()"
              placeholder="เช่น งานอีเวนต์ / ผู้ติดต่อราชการ"
              class="w-full px-4 py-3 rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-amber-200 resize-none"></textarea>
          </div>
        </div>

        <!-- Right: file + preview -->
        <div class="space-y-4 min-w-0">
          <div class="flex items-center justify-between gap-2">
            <div class="flex items-center gap-2 text-sm font-black text-slate-700 dark:text-slate-200">
              <span class="w-6 h-6 rounded-full bg-amber-400 text-white text-xs flex items-center justify-center">2</span>
              เลือกไฟล์ทะเบียนรถ
            </div>
            <button type="button" (click)="downloadTemplate()"
              class="inline-flex items-center gap-1 text-xs font-bold text-amber-600 hover:text-amber-500 bg-transparent border-none cursor-pointer">
              <span class="material-icons text-[16px]">download</span> ไฟล์ตัวอย่าง
            </button>
          </div>

          <label *ngIf="!fileName"
            class="flex flex-col items-center justify-center gap-2 h-[150px] rounded-2xl border-2 border-dashed border-slate-200 dark:border-slate-700 hover:border-amber-300 hover:bg-amber-50/40 dark:hover:bg-amber-900/10 cursor-pointer transition-colors text-center px-4">
            <span class="material-icons text-4xl text-slate-300">cloud_upload</span>
            <span class="text-sm font-bold text-slate-600 dark:text-slate-300">คลิกเพื่อเลือกไฟล์ (.xlsx, .xls, .csv, .txt)</span>
            <span class="text-[11px] text-slate-400">ใช้คอลัมน์แรกเป็นทะเบียนรถเท่านั้น · ระบบตัดช่องว่างให้ชิดกันอัตโนมัติ · สูงสุด {{ maxPlates }} คัน</span>
            <input type="file" accept=".xlsx,.xls,.csv,.txt" class="hidden" (change)="onFileSelected($event)">
          </label>

          <ng-container *ngIf="fileName">
            <div class="flex items-center justify-between gap-3 px-4 py-3 rounded-2xl bg-slate-50 dark:bg-slate-800/60 border border-slate-100 dark:border-slate-700">
              <div class="flex items-center gap-2 min-w-0">
                <span class="material-icons text-emerald-500">description</span>
                <span class="text-sm font-bold text-slate-700 dark:text-slate-200 truncate">{{ fileName }}</span>
              </div>
              <button type="button" (click)="clearFile()" [disabled]="isImporting()"
                class="text-xs font-bold text-rose-500 hover:text-rose-600 bg-transparent border-none cursor-pointer shrink-0">เปลี่ยนไฟล์</button>
            </div>

            <div class="grid grid-cols-2 sm:grid-cols-4 gap-2">
              <div class="rounded-xl bg-slate-50 dark:bg-slate-800/60 px-3 py-2">
                <p class="text-[10px] font-bold text-slate-400 uppercase">ทะเบียนในไฟล์</p>
                <p class="text-lg font-black text-slate-800 dark:text-slate-100 tabular-nums">{{ previewRows.length | number }}</p>
              </div>
              <div class="rounded-xl bg-emerald-50 dark:bg-emerald-900/20 px-3 py-2">
                <p class="text-[10px] font-bold text-emerald-600 uppercase">ไม่ซ้ำ (จะส่ง)</p>
                <p class="text-lg font-black text-emerald-700 dark:text-emerald-300 tabular-nums">{{ uniqueCount | number }}</p>
              </div>
              <div class="rounded-xl bg-amber-50 dark:bg-amber-900/20 px-3 py-2">
                <p class="text-[10px] font-bold text-amber-600 uppercase">ปรับให้ชิดกัน</p>
                <p class="text-lg font-black text-amber-700 dark:text-amber-300 tabular-nums">{{ changedCount | number }}</p>
              </div>
              <div class="rounded-xl bg-rose-50 dark:bg-rose-900/20 px-3 py-2">
                <p class="text-[10px] font-bold text-rose-500 uppercase">ซ้ำในไฟล์</p>
                <p class="text-lg font-black text-rose-600 dark:text-rose-300 tabular-nums">{{ duplicateCount | number }}</p>
              </div>
            </div>

            <p *ngIf="emptyRowCount > 0" class="text-[11px] text-slate-400">ข้ามแถวว่าง {{ emptyRowCount | number }} แถว</p>
            <p *ngIf="overLimit" class="text-xs font-bold text-rose-500">
              ไฟล์มี {{ previewRows.length | number }} คัน เกินกำหนด {{ maxPlates }} คันต่อครั้ง — กรุณาแบ่งไฟล์
            </p>

            <div class="rounded-2xl border border-slate-100 dark:border-slate-700 overflow-hidden">
              <div class="max-h-[260px] overflow-y-auto custom-scrollbar">
                <table class="w-full text-left text-sm">
                  <thead class="sticky top-0 bg-slate-50 dark:bg-slate-800 text-[11px] font-bold text-slate-400 uppercase">
                    <tr>
                      <th class="px-3 py-2 w-[60px]">แถว</th>
                      <th class="px-3 py-2">ในไฟล์</th>
                      <th class="px-3 py-2">ทะเบียนที่ใช้</th>
                      <th class="px-3 py-2 w-[110px]">หมายเหตุ</th>
                    </tr>
                  </thead>
                  <tbody class="divide-y divide-slate-50 dark:divide-slate-800">
                    <tr *ngFor="let row of previewRows" [class.opacity-50]="row.duplicate">
                      <td class="px-3 py-2 text-xs text-slate-400 tabular-nums">{{ row.rowNo }}</td>
                      <td class="px-3 py-2 text-slate-500 whitespace-pre">{{ row.raw }}</td>
                      <td class="px-3 py-2">
                        <span class="inline-flex px-2 py-0.5 rounded-lg text-xs font-black bg-amber-100 text-amber-900 dark:bg-amber-900/40 dark:text-amber-300">{{ row.plate }}</span>
                      </td>
                      <td class="px-3 py-2 text-[11px] font-bold">
                        <span *ngIf="row.duplicate" class="text-rose-500">ซ้ำในไฟล์</span>
                        <span *ngIf="!row.duplicate && row.changed" class="text-amber-600">ตัดช่องว่าง</span>
                        <span *ngIf="!row.duplicate && !row.changed" class="text-emerald-600">พร้อม</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </ng-container>
        </div>
      </div>

      <div class="mt-6 rounded-2xl bg-sky-50 dark:bg-sky-900/20 border border-sky-100 dark:border-sky-800/40 px-4 py-3 text-xs text-sky-700 dark:text-sky-300 leading-relaxed flex gap-2">
        <span class="material-icons text-[18px]">info</span>
        <span>
          ระบบจะสร้างช่วงยกเว้นทีละคันและส่งไป Taiwan ทีละรายการ · ทะเบียนที่ซ้ำในไฟล์ หรือมีช่วงยกเว้นที่เปิดอยู่ทับซ้อนช่วงเวลานี้แล้ว จะถูกข้าม
          · จำนวนมากอาจใช้เวลาหลายนาที กรุณาอย่าปิดหน้านี้ระหว่างนำเข้า
        </span>
      </div>
    </div>

    <!-- ================= RESULT ================= -->
    <div *ngIf="step() === 'result' && result" class="flex-1 overflow-y-auto custom-scrollbar px-6 py-6 space-y-5">
      <div class="grid grid-cols-2 md:grid-cols-4 gap-3">
        <button type="button" (click)="resultFilter = 'all'"
          class="text-left rounded-2xl px-4 py-3 border transition-all cursor-pointer"
          [ngClass]="resultFilter === 'all' ? 'border-slate-400 bg-slate-50 dark:bg-slate-800' : 'border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-900'">
          <p class="text-[11px] font-bold text-slate-400 uppercase">ทั้งหมด</p>
          <p class="text-2xl font-black text-slate-800 dark:text-slate-100 tabular-nums">{{ result.total | number }}</p>
        </button>
        <button type="button" (click)="resultFilter = 'success'"
          class="text-left rounded-2xl px-4 py-3 border transition-all cursor-pointer"
          [ngClass]="resultFilter === 'success' ? 'border-emerald-400 bg-emerald-50 dark:bg-emerald-900/20' : 'border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-900'">
          <p class="text-[11px] font-bold text-emerald-600 uppercase">สำเร็จ</p>
          <p class="text-2xl font-black text-emerald-600 tabular-nums">{{ result.successCount | number }}</p>
        </button>
        <button type="button" (click)="resultFilter = 'skipped'"
          class="text-left rounded-2xl px-4 py-3 border transition-all cursor-pointer"
          [ngClass]="resultFilter === 'skipped' ? 'border-amber-400 bg-amber-50 dark:bg-amber-900/20' : 'border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-900'">
          <p class="text-[11px] font-bold text-amber-600 uppercase">ข้าม</p>
          <p class="text-2xl font-black text-amber-600 tabular-nums">{{ result.skippedCount | number }}</p>
        </button>
        <button type="button" (click)="resultFilter = 'failed'"
          class="text-left rounded-2xl px-4 py-3 border transition-all cursor-pointer"
          [ngClass]="resultFilter === 'failed' ? 'border-rose-400 bg-rose-50 dark:bg-rose-900/20' : 'border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-900'">
          <p class="text-[11px] font-bold text-rose-500 uppercase">ไม่สำเร็จ</p>
          <p class="text-2xl font-black text-rose-500 tabular-nums">{{ result.failedCount | number }}</p>
        </button>
      </div>

      <div class="flex flex-wrap items-center justify-between gap-2 text-xs font-bold text-slate-500">
        <span class="inline-flex items-center gap-1.5">
          <span class="material-icons text-[16px] text-amber-500">event_available</span>{{ rangePreview }}
        </span>
        <button type="button" (click)="exportResult()"
          class="inline-flex items-center gap-1 px-3 py-1.5 rounded-xl border border-slate-200 dark:border-slate-700 text-slate-600 dark:text-slate-300 hover:border-emerald-400 hover:text-emerald-600 bg-white dark:bg-slate-800 cursor-pointer">
          <span class="material-icons text-[16px]">file_download</span> ดาวน์โหลดผลเป็น Excel
        </button>
      </div>

      <div class="rounded-2xl border border-slate-100 dark:border-slate-700 overflow-hidden">
        <div class="max-h-[380px] overflow-y-auto custom-scrollbar">
          <table class="w-full text-left text-sm">
            <thead class="sticky top-0 bg-slate-50 dark:bg-slate-800 text-[11px] font-bold text-slate-400 uppercase">
              <tr>
                <th class="px-4 py-2.5 w-[60px]">#</th>
                <th class="px-4 py-2.5">ทะเบียน</th>
                <th class="px-4 py-2.5 w-[110px]">สถานะ</th>
                <th class="px-4 py-2.5">รายละเอียด</th>
              </tr>
            </thead>
            <tbody class="divide-y divide-slate-50 dark:divide-slate-800">
              <tr *ngFor="let item of filteredResultItems; let i = index">
                <td class="px-4 py-2.5 text-xs text-slate-400 tabular-nums">{{ i + 1 }}</td>
                <td class="px-4 py-2.5">
                  <span class="inline-flex px-2 py-0.5 rounded-lg text-xs font-black bg-amber-100 text-amber-900 dark:bg-amber-900/40 dark:text-amber-300">{{ item.licensePlate || '—' }}</span>
                  <span *ngIf="item.rawLicensePlate && item.rawLicensePlate !== item.licensePlate"
                    class="block text-[10px] text-slate-400 mt-0.5">ในไฟล์: {{ item.rawLicensePlate }}</span>
                </td>
                <td class="px-4 py-2.5">
                  <span class="px-2 py-0.5 rounded-lg text-[11px] font-bold"
                    [ngClass]="item.status === 'success'
                      ? 'bg-emerald-50 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-300'
                      : item.status === 'skipped'
                        ? 'bg-amber-50 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300'
                        : 'bg-rose-50 text-rose-600 dark:bg-rose-900/30 dark:text-rose-300'">
                    {{ statusLabel(item.status) }}
                  </span>
                </td>
                <td class="px-4 py-2.5 text-xs text-slate-600 dark:text-slate-300">{{ item.message || '—' }}</td>
              </tr>
              <tr *ngIf="filteredResultItems.length === 0">
                <td colspan="4" class="px-4 py-10 text-center text-sm text-slate-400">ไม่มีรายการในกลุ่มนี้</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="flex-none px-6 py-4 border-t border-slate-100 dark:border-slate-800 flex items-center justify-end gap-3 rounded-b-[2rem] bg-slate-50/60 dark:bg-slate-900/60">
      <ng-container *ngIf="step() === 'form'">
        <button type="button" (click)="onClose()" [disabled]="isImporting()"
          class="px-4 h-[42px] rounded-xl border border-slate-200 dark:border-slate-700 text-slate-600 dark:text-slate-300 font-bold bg-transparent cursor-pointer disabled:opacity-50">
          ยกเลิก
        </button>
        <button type="button" (click)="askSubmit()" [disabled]="!canSubmit"
          class="px-5 h-[42px] rounded-xl bg-amber-400 hover:bg-amber-500 text-white font-bold cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed inline-flex items-center gap-1.5 border-none">
          <span class="material-icons text-[18px]">upload</span>
          นำเข้า {{ uniqueCount | number }} คัน
        </button>
      </ng-container>
      <ng-container *ngIf="step() === 'result'">
        <button type="button" (click)="importAnother()"
          class="px-4 h-[42px] rounded-xl border border-slate-200 dark:border-slate-700 text-slate-600 dark:text-slate-300 font-bold bg-transparent cursor-pointer hover:border-amber-400 hover:text-amber-600">
          นำเข้าไฟล์ใหม่
        </button>
        <button type="button" (click)="onClose()"
          class="px-5 h-[42px] rounded-xl bg-amber-400 hover:bg-amber-500 text-white font-bold cursor-pointer border-none">
          เสร็จสิ้น
        </button>
      </ng-container>
    </div>
  </div>
</div>

<app-pss-confirm-modal *ngIf="showConfirm"
  title="ยืนยันการนำเข้า?"
  message="นำเข้าทะเบียนรถ"
  [highlight]="(uniqueCount | number) + ' คัน'"
  [messageSuffix]="'ช่วง ' + rangePreview + ' — ระบบจะส่ง Taiwan ทีละคัน'"
  confirmLabel="นำเข้า"
  cancelLabel="ยกเลิก"
  variant="warning"
  icon="upload_file"
  [showIrreversibleNote]="false"
  (confirm)="confirmSubmit()"
  (cancel)="showConfirm = false">
</app-pss-confirm-modal>

<app-pss-loading *ngIf="isImporting() || isReading()"></app-pss-loading>
